import type { UserCompany } from '../types';

export type TenantCreateFormState = {
  name: string;
  full_name: string;
  license_type: number;
};

export type TenantNotice = {
  type: 'success' | 'error';
  text: string;
};

export const EMPTY_TENANT_CREATE_FORM: TenantCreateFormState = {
  name: '',
  full_name: '',
  license_type: 1,
};

export const shortCompanyId = (value?: string | null) => (value ? value.slice(0, 8) : '-');

export const mergeTenantCompanies = (
  parentCompany: UserCompany | undefined,
  userCompanies: UserCompany[],
  apiTenants: UserCompany[]
) => {
  const byId = new Map<string, UserCompany>();
  userCompanies
    .filter((company) => {
      if (!parentCompany || company.id === parentCompany.id) return false;
      return company.parent_company_id === parentCompany.id || company.is_tenant;
    })
    .forEach((company) => byId.set(company.id, company));

  apiTenants.forEach((company) => byId.set(company.id, company));
  return Array.from(byId.values()).sort((a, b) => a.name.localeCompare(b.name, 'ru'));
};
